"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/layout/style/css");

var _layout = _interopRequireDefault(require("antd/es/layout"));

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _typesafeActions = require("typesafe-actions");

var _reactRouterDom = require("react-router-dom");

var _api = require("../../../redux/api/api.types");

var _MessageList = _interopRequireDefault(require("../../../components/inbox/MessageList"));

var _NoThreadSelected = _interopRequireDefault(require("../../../components/inbox/NoThreadSelected"));

var _ThreadList = _interopRequireDefault(require("../../../components/inbox/ThreadList"));

var _messages = require("../../../redux/messages/messages.types");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

require("./inbox.scss");

var _participants = require("../../../redux/participants/participants.types");

var _avatar = require("../../../redux/avatar/avatar.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Sider,
  Content
} = _layout.default;

class Inbox extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      activeThreadId: -1,
      responses: this.props.responses,
      pageNumber: 0,
      previewLength: 40,
      pageSize: 10,
      hasMore: true,
      loading: false,
      hasMoreMessages: true,
      loadingMessages: false,
      searchTerm: '',
      sortBy: 'newest'
    };

    this.setActiveThread = threadId => {
      const {
        getMessages
      } = this.props;
      const {
        activeThreadId
      } = this.state;
      getMessages({
        pageSize: 16,
        threadId
      });

      if (activeThreadId !== threadId) {
        this.setState({
          activeThreadId: threadId
        });
      }
    };

    this.refreshThreads = () => {
      this.handleInfiniteLoad(0);
    };

    this.getMessages = (pageSize, pageNumber) => {
      const {
        getMessages
      } = this.props;
      const {
        activeThreadId
      } = this.state;
      getMessages({
        threadId: activeThreadId,
        pageSize,
        pageNumber
      });
    };

    this.handleInfiniteLoad = pageNumberParamFromInfiniteLoader => {
      const {
        loadInboxStatus,
        loadInbox,
        view = 'all',
        filterBy = 'None'
      } = this.props;
      const {
        previewLength,
        pageNumber,
        pageSize,
        searchTerm,
        sortBy
      } = this.state;

      if (loadInboxStatus.isError) {
        this.setState({
          loading: false
        });
      } else {
        loadInbox({
          previewLength,
          pageNumber,
          pageSize,
          searchTerm,
          view,
          filterBy,
          sortBy
        });
        this.setState({
          pageNumber: pageNumber + 1,
          loading: true
        });
      }
    };

    this.debouncedSearch = _lodash._.debounce(this.handleInfiniteLoad, 500);

    this.handleSearch = searchTerm => {
      const {
        studyId,
        clearMessages
      } = this.props;
      this.props.history.push(`/study/${studyId}/inbox?view=all`);
      this.setState({
        pageNumber: 0,
        searchTerm,
        view: 'all',
        filterBy: 'none',
        hasMore: true,
        pageSize: 10,
        loading: true
      }, () => {
        clearMessages();
        this.debouncedSearch(-1);
      });
    };

    this.setView = view => {
      const {
        filterBy
      } = this.props;
      this.recallHandleInfiniteLoadAfterFilterUpdate(view, filterBy);
    };

    this.setFilterBy = filterBy => {
      const {
        view
      } = this.props;
      this.recallHandleInfiniteLoadAfterFilterUpdate(view, filterBy);
    };

    this.setSortBy = sortBy => {
      const {
        threads
      } = this.props;
      const {
        pageSize
      } = this.state; // We want to retain the same number of records when we sort

      let newPageSize = pageSize;

      if (threads && threads.length && threads.length > pageSize) {
        newPageSize = threads.length;
      }

      this.setState({
        pageNumber: 0,
        sortBy,
        searchTerm: undefined,
        pageSize: newPageSize
      }, () => {
        (0, _messages.clearMessages)();
        this.handleInfiniteLoad(-1);
      });
    };

    this.recallHandleInfiniteLoadAfterFilterUpdate = (view, filterBy) => {
      const {
        clearMessages,
        studyId
      } = this.props;
      let url = `/study/${studyId}/inbox?view=${view}`;

      if (!_lodash._.isEmpty(filterBy)) {
        url += `&filterBy=${filterBy}`;
      }

      this.props.history.push(url);
      this.setState({
        pageNumber: 0,
        searchTerm: '',
        pageSize: 10,
        hasMore: true
      }, () => {
        clearMessages();
        this.handleInfiniteLoad(-1);
      });
    };

    this.onScroll = event => {
      if (!event.target) return;
      const {
        scrollHeight,
        clientHeight,
        scrollTop
      } = event.target;

      if (Math.round(scrollHeight - scrollTop) === clientHeight) {
        let {
          pageNumber
        } = this.state;
        pageNumber++;
        this.setState({
          pageNumber
        });
        this.handleInfiniteLoad(pageNumber);
      }
    };
  }

  componentDidMount() {
    const {
      getMessages,
      getParticipants,
      studyId,
      getAvatars
    } = this.props;
    const {
      activeThreadId
    } = this.state;
    this.handleInfiniteLoad(0);

    if (activeThreadId !== -1) {
      getMessages({
        threadId: activeThreadId
      });
    }

    if (studyId) {
      getParticipants(studyId);
    }

    getAvatars();
  }

  componentDidUpdate(prevProps) {
    var _a;

    const {
      loading
    } = this.state;
    const {
      loadInboxStatus,
      threads,
      threadCount,
      createMessageThreadStatus,
      clearStatus
    } = this.props;

    if (!prevProps.loadInboxStatus.isSuccess && loadInboxStatus.isSuccess) {
      // If the activeThreadId isn't in the current threads, reset it.
      if (!((_a = this.props.threads) === null || _a === void 0 ? void 0 : _a.filter(t => t.id === this.state.activeThreadId).length)) {
        this.setState({
          activeThreadId: undefined,
          loading: false
        });
      } else {
        this.setState({
          loading: false
        });
      }
    }

    if (loading && threads && threadCount === threads.length) {
      this.setState({
        loading: false
      });
    } // Check create thread async status


    if (!prevProps.createMessageThreadStatus.isError && createMessageThreadStatus.isError) {
      _message2.default.error(`Error: ${createMessageThreadStatus.errorMessage}`);

      clearStatus((0, _typesafeActions.getType)(_messages.createThreadAsync.failure));
    }

    if (!prevProps.createMessageThreadStatus.isSuccess && createMessageThreadStatus.isSuccess) {
      _message2.default.success('Thread created successfully.');

      clearStatus((0, _typesafeActions.getType)(_messages.createThreadAsync.success));
    }
  }

  render() {
    const {
      activeThreadId,
      loading,
      sortBy,
      searchTerm
    } = this.state;
    const {
      responses,
      threads,
      loadInboxStatus,
      view = 'all',
      filterBy = 'None'
    } = this.props;
    const {
      userId
    } = this.props;

    const response = _lodash._.filter(responses, response => response.threadId === activeThreadId)[0];

    return /*#__PURE__*/_react.default.createElement(_layout.default, {
      className: "inbox"
    }, /*#__PURE__*/_react.default.createElement(Sider, {
      collapsible: false,
      style: {
        backgroundColor: 'white'
      },
      width: 400
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "sidebar"
    }, /*#__PURE__*/_react.default.createElement(_ThreadList.default, {
      setActiveThread: this.setActiveThread,
      activeThreadId: activeThreadId,
      userId: userId,
      handleSearch: this.handleSearch,
      searchTerm: searchTerm,
      setView: this.setView,
      setFilterBy: this.setFilterBy,
      setSortBy: this.setSortBy,
      refreshThreads: this.refreshThreads,
      view: view,
      filterBy: filterBy,
      sortBy: sortBy,
      onScroll: this.onScroll
    }))), /*#__PURE__*/_react.default.createElement(Content, {
      className: "scrollable content"
    }, activeThreadId !== -1 && response ? /*#__PURE__*/_react.default.createElement(_MessageList.default, {
      userId: userId || -1,
      response: response,
      getMessages: this.getMessages
    }) : /*#__PURE__*/_react.default.createElement(_NoThreadSelected.default, null)));
  }

}

const mapStateToProps = state => {
  return {
    studyId: selectors.getRequestedStudyId(state),
    userId: state.auth.user ? state.auth.user.id : -1,
    responses: selectors.getMessageResponses(state),
    messages: selectors.getMessages(state),
    loadInboxStatus: selectors.loadMessageInboxStatus(state),
    createMessageThreadStatus: selectors.createMessageThreadStatus(state),
    threadCount: selectors.getMessageThreadCount(state),
    threads: selectors.getMessageThreads(state),
    view: selectors.getRequestedInboxView(state),
    filterBy: selectors.getRequestedInboxFilterBy(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAvatars: () => dispatch(_avatar.getAvatarsAsync.request()),
    getParticipants: studyId => dispatch(_participants.getParticipantsByStudyAsync.request(studyId)),
    loadInbox: args => dispatch(_messages.getMessageInboxAsync.request(args)),
    getMessages: args => dispatch(_messages.getMessagesAsync.request(args)),
    clearMessages: () => dispatch((0, _messages.clearMessages)()),
    clearStatus: type => dispatch((0, _api.clearStatus)(type))
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Inbox));

exports.default = _default;